import axiosPrivate from "./axiosPrivate";

const getCajaFinancieroPresupuesto = (perfil_id, usuario_id, periodo_fecha) => {
    return axiosPrivate.get("caja-financiero-presupuesto", {
        params: {
            perfil_id,
            usuario_id,
            periodo_fecha
        }
    }).then(response => response.data);
};

const insertCajaFinancieroPresupuesto = (data) => {
    return axiosPrivate.post("caja-financiero-presupuesto", data)
        .then(response => response.data);
};

const updateCajaFinancieroPresupuesto = (data) => {
    return axiosPrivate.put("caja-financiero-presupuesto", data)
        .then(response => response.data);
};

const deleteCajaFinancieroPresupuesto = (data) => {
    return axiosPrivate.delete("caja-financiero-presupuesto", { data })
        .then(response => response.data);
};

const getPresupuestoDisponible = (periodo_fecha) => {
    return axiosPrivate.post("presupuesto-disponible", { periodo_fecha })
        .then(response => response.data);
};

export default {
    getCajaFinancieroPresupuesto,
    insertCajaFinancieroPresupuesto,
    updateCajaFinancieroPresupuesto,
    deleteCajaFinancieroPresupuesto,
    getPresupuestoDisponible
};
